import { render, staticRenderFns } from "./GetDesktopImg.vue?vue&type=template&id=d39b9080&"
import script from "./GetDesktopImg.vue?vue&type=script&lang=js&"
export * from "./GetDesktopImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports